export default __webpack_public_path__ + "static/media/female.cfe228b7.svg";